<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.salesflow-btn:disabled {
  cursor: not-allowed;
  background-color: #F0F0F0;
  color: #AAAAAB;
  border-color: #F0F0F0;
}

.table-responsive {
  margin: 0;
  border: 4px solid transparent;
  background-color: white;
  min-height: 57vh;
}

.table-responsive table {
  overflow-x: scroll;
}

.table-responsive table thead {
  background-color: white;
  position: sticky;
  top: 0px;
  outline: 1px solid var(--salesflow-outline-gray-medium);
}

.table-responsive table thead th {
  background-color: white;
  border-top: 0px;
  font-weight: 500 !important;
  color: var(--salesflow-font-gray);
  font-size: 12px;
  line-height: 150%;
  padding: 21px 8px !important;
}

.table-responsive table thead th:first-child {
  padding-left: 40px !important;
}

.table-responsive table tbody {
  background-color: white;
}

.table-responsive table tbody tr td {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 150% !important;
  color: var(--salesflow-font-dark) !important;
}

.invoice a {
  font-weight: 500;
  font-size: 12px;
}

.table-responsive table tbody th,
.table-responsive table tbody td,
.table-responsive table thead th {
  border: none;
}

.table-responsive table thead th {
  border-bottom: 1px solid $salesflow-outline-gray-medium;
}

.table-responsive table tbody tr {
  border-bottom: 1px solid $salesflow-outline-gray-medium;
  height: 50px;
}

.table-responsive table tbody tr td {
  padding: 16px 8px !important;
  vertical-align: middle;
}

.table-responsive table tbody tr td:first-child,
.table-responsive table thead th:first-child {
  padding-left: 40px !important;
}

.table-responsive table tbody tr td:last-child,
.table-responsive table thead th:last-child {
  padding-right: 40px !important;
}

.table-responsive table tbody tr td a {
  text-decoration: none;
}

.table-responsive table tbody td a:hover {
  text-decoration: underline;
}

.table-responsive table tbody td .editable {
  margin: 0 !important;
}


tbody tr td a {
  font-size: 13px;
  font-weight: 400;
  -webkit-text-stroke: thin;
}

.load-more {
  background: transparent;
  border: 0px;
  outline: 0px;

  @include salesflow-text;

  &:hover {
    color: $salesflow-primary-hover;
  }
}

#billing-show {
  color: $salesflow-font-dark;
  font-family: Montserrat;
  font-size: 12px;


  .row.financial-info {
    margin: 0 0 16px 0;

    .financial-info-col {
      padding: 12px !important;

      .card {
        height: 100%;
        background-color: $salesflow-background-content;
      }
    }

    .financial-info-col:first-of-type {
      padding-left: 0px !important;
    }

    .financial-info-col:last-of-type {
      padding-right: 0px !important;
    }

    .financial-info-data {
      margin-left: 16px;

      h4.subtitle {
        color: $salesflow-font-gray;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      h3.name {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 8px;
        color: $salesflow-font-dark;
      }

      h4.company_name {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
        color: $salesflow-font-dark;
      }

      p.address {
        font-size: 12px;
        margin-bottom: 16px;
        font-weight: 500;
        color: $salesflow-font-dark;
      }

      a.btn-update-financial-info {
        border: 1px solid $salesflow-font-gray;
        color: $salesflow-font-gray;
        font-size: 12px;
        font-weight: 600;
        border-radius: 14px;
        padding: 8px 16px;

        svg {
          margin-right: 8px;
          fill: $salesflow-font-gray;
        }
      }

      a.btn-update-financial-info:hover {
        border: 1px solid $salesflow-primary;
        color: $salesflow-primary;

        svg {
          fill: $salesflow-primary;
        }
      }
    }

    .plan-info-data {
      margin-left: 16px;

      h4.subtitle {
        color: $salesflow-font-gray;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      h3.name {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 8px;
      }

      h4.lead-limit {
        font-size: 16px;
        color: $salesflow-font-dark;
        font-weight: 700;
      }

      a {
        text-decoration: none;
      }

      a.btn-plan-outline {
        background: none;
        color: $salesflow-primary;
        border: 1px solid $salesflow-primary;
      }

      a.btn-plan-outline:hover {
        background-color: $salesflow-primary-hover;
        border: 1px solid $salesflow-primary-hover;
        color: white;
      }
    }
  }

  .header-divisor {
    margin: 20px -45px;
  }

  .shadow {
    -webkit-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
  }


  .row.board {
    background-color: $salesflow-background-content;
    min-height: 44vh;
    margin-top: 0px;

    .header-name {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: -0.18px;
      line-height: 20px;
      margin-bottom: 0px;
    }

    .header-text {
      font-size: 12px;
      letter-spacing: -0.18px;
      line-height: 20px;
      -webkit-text-stroke: thin;
      text-overflow: ellipsis;
      max-width: 441px;

      b {
        font-weight: 700;
        -webkit-text-stroke: black;
      }
    }

    .header-address {
      margin-top: 26px;
    }
  }

  .middle-title-row {
    display: flex;
    align-items: center;
    justify-content: center;

    .middle-title {
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.24px;
      line-height: 20px;
    }
  }

  @media (max-width: 1500px) {
    .btn {
      font-size: 11px;
    }
  }
}
</style>

<template>
  <div id="billing-show">
    <div class="row">
      <div class="col-9 pl-30px">
        <h1 class="page-title text-left">
          {{ __('Minha Assinatura') }}
        </h1>
      </div>
      <div class="col-3" />
    </div>
    <div class="row">
      <div class="col-8 pl-30px">
        <h2 class="page-subtitle">
          {{ __('Detalhes da sua assinatura') }}
        </h2>
      </div>
      <div class="col-4 text-right" />
    </div>

    <template v-if="tenant">
      <div class="row financial-info">
        <div class="col-7 financial-info-col">
          <div class="card shadow bdk-px-10 bdk-py-6 d-flex flex-row align-items-center">
            <Avatar class="avatar-lg circle" :name="tenant.name" width="88" heigth="88" style="display: inline-grid;" />
            <div class="financial-info-data">
              <h4 class="subtitle">{{ __('Meus dados') }}</h4>
              <h3 class="name">{{ tenant.name }}</h3>
              <h4 class="company_name">{{ __('Empresa:') }} {{ tenant.company_name }}</h4>
              <p class="address" v-if="tenant.address">
                {{ tenant.address.street }},
                {{ tenant.address.number }}
                <span v-if="tenant.address.complement">- {{ tenant.address.complement }}.</span>
                {{ tenant.address.district }}.
                {{ tenant.address.city }}/{{ tenant.address.state }}.
                {{ __('CEP') }}: {{ cep }}
              </p>
              <a href="/billing/update" class="btn btn-update-financial-info">
                <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.5017 1.94039C15.5951 2.03412 15.6476 2.16106 15.6476 2.29339C15.6476 2.42573 15.5951 2.55267 15.5017 2.64639L14.4587 3.69039L12.4587 1.69039L13.5017 0.646393C13.5955 0.552658 13.7226 0.5 13.8552 0.5C13.9878 0.5 14.115 0.552658 14.2087 0.646393L15.5017 1.93939V1.94039ZM13.7517 4.39639L11.7517 2.39639L4.93872 9.21039C4.88368 9.26542 4.84225 9.33253 4.81772 9.40639L4.01272 11.8204C3.99812 11.8644 3.99604 11.9116 4.00673 11.9567C4.01741 12.0018 4.04044 12.0431 4.07322 12.0759C4.10601 12.1087 4.14727 12.1317 4.19239 12.1424C4.23751 12.1531 4.28471 12.151 4.32872 12.1364L6.74272 11.3314C6.81648 11.3072 6.88359 11.2661 6.93872 11.2114L13.7517 4.39739V4.39639Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1 13.5C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V7.5C15 7.36739 14.9473 7.24021 14.8536 7.14645C14.7598 7.05268 14.6326 7 14.5 7C14.3674 7 14.2402 7.05268 14.1464 7.14645C14.0527 7.24021 14 7.36739 14 7.5V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H9C9.13261 2 9.25979 1.94732 9.35355 1.85355C9.44732 1.75979 9.5 1.63261 9.5 1.5C9.5 1.36739 9.44732 1.24021 9.35355 1.14645C9.25979 1.05268 9.13261 1 9 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V13.5Z" />
                </svg>
                {{ __('Atualizar meus dados') }}</a>
            </div>
          </div>
        </div>
        <div class="col-5 financial-info-col">
          <div class="card shadow bdk-px-10 bdk-py-6 d-flex">
            <div class="plan-info-data">
              <h4 class="subtitle">{{ __('Dados do plano') }}</h4>
              <h3 class="name">{{ __('Plano') }} {{ tenant.plan.name }}</h3>
              <h4 class="lead-limit bdk-mb-6">Até {{ tenant.plan.leads }} leads</h4>
              <div class="d-flex bdk-gap-6">
                <a :href="tenant.last_invoice.url" class="salesflow-btn salesflow-btn-primary btn-plan-outline">
                  {{ __('Visualizar Fatura') }}</a>
                  <div v-b-tooltip.hover="{
                      customClass: 'mb-2'
                    }"
                    :title="!can_upgrade ? 'Upgrade indisponível: faturas pendentes' : ''"
                  >
                    <button @click="redirectToBillingPlans" :class="`salesflow-btn-primary salesflow-btn `" :disabled="!can_upgrade">
                      {{ __('Fazer upgrade') }}
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin: 8px 0;" class="row board shadow px-4 pt-4 mt-2">
        <div class="col-md-12" id="edit-billing-core">
          <div class="row">
            <div class="w-100">
              <div class="row middle-title-row">
                <h5 class="middle-title fw-700">
                  {{ __('Histórico de pagamentos') }}
                </h5>
              </div>
              <div class="row board w-100">
                <div class="table-responsive border border-salesflow-outline-gray-medium" style="border-radius: 24px;">
                  <table class="table table-borderless" style="max-height: 60%;">
                    <thead>
                      <tr>
                        <th class="sticky-top pl-30px text-center">
                          {{ __('Data') }}
                        </th>
                        <th class="sticky-top text-center">
                          {{ __('Status') }}
                        </th>
                        <th class="sticky-top text-center">
                          {{ __('Período') }}
                        </th>
                        <th class="sticky-top text-center">
                          {{ __('Valor') }}
                        </th>
                        <th class="sticky-top text-center">
                          {{ __('Fatura') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="invoice in invoices">
                        <td class="small-font-size pl-30px text-center">
                          {{ invoice.created_at | datetime('LD') }}
                        </td>
                        <td class="text-center">
                          {{ invoice.status_description }}
                        </td>
                        <td class="text-center">
                          {{ invoice.created_at | datetime('LD') }} {{ __('até') }} {{ invoice.due_at | datetime('LD')
                          }}
                        </td>
                        <td class="text-center">
                          R$ {{ invoice.total | number }}
                        </td>
                        <td class="text-center invoice">
                          <a :href="invoice.url" target="_blank">{{__('Visualizar fatura')}}</a>
                        </td>
                      </tr>
                      <tr v-if="isLoading || currentPage < lastPage">
                        <td class="text-center align-middle" colspan="5">
                          <button id="load-more" class="load-more" v-if="!isLoading" @click="getBillingData">
                            {{__('Carregar mais')}}
                          </button>
                          <div v-else class="spinner-container">
                            <i class="fa fa-circle-o-notch fa-spin" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-if="!tenant && isLoading" class="w-100 mt-72px d-flex align-items-center justify-content-center">
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  props: {
    can_upgrade: {
      type: Boolean,
      required: false
    }
  }, 

  directives: {
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      tenant: null,
      invoices: [],
      currentPage: 0,
      lastPage: null,
      isLoading: false,
    };
  },
  computed: {
    cep() {
      const aux = this.tenant.address.postalcode;

      return `${aux.substr(0, 5)}-${aux.substr(4, 3)}`;
    },
  },

  created() {
    this.getBillingData();
  },

  methods: {
    redirectToBillingPlans() {
      window.location.href = 'billing/plans';
    },

    getBillingData() {
      if (this.lastPage && this.currentPage >= this.lastPage) {
        Alert.error('Você já alcançou a última página');
        return;
      }

      this.isLoading = true;

      this.$http.get(`/billing/details?page=${this.currentPage + 1}`).then(({ data }) => {
        this.tenant = data.tenant;
        this.invoices = this.invoices.concat(data.invoices.data);
        this.currentPage = data.invoices.current_page;
        this.lastPage = data.invoices.last_page;
      }).catch((error) => {
        console.error(error);
        Alert.error('Ocorreu um erro inesperado!');
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
